import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error('Session invalide');
          navigate('/login');
          return;
        }

        // Call backend to exchange session_id for user data
        const API_URL = process.env.REACT_APP_BACKEND_URL || '';
        const response = await fetch(`${API_URL}/api/auth/google/callback`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.detail || 'Erreur d\'authentification');
        }

        const userData = await response.json();

        // Login with Google data
        const result = loginWithGoogle(userData);
        
        if (result.success) {
          if (result.isNewUser) {
            toast.success('Compte créé avec succès! Bienvenue!');
          } else {
            toast.success('Connexion réussie!');
          }
          navigate('/dashboard');
        } else {
          toast.error('Erreur lors de la connexion');
          navigate('/login');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error(error.message || 'Erreur d\'authentification');
        navigate('/login');
      }
    };

    processAuth();
  }, [loginWithGoogle, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
        <p className="text-muted-foreground">Connexion en cours...</p>
      </div>
    </div>
  );
}
